module.exports = __webpack_public_path__ + "static/media/youtube15.9d356b3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-icons/youtube15.svg
// module id = 549
// module chunks = 0